import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {CREATE_SERIES, HOME} from "./route";

const AuthCallbackHandler = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');
        const seriesId = searchParams.get('seriesId');

        console.log('URL Debug:', {
            currentUrl: location.pathname + location.search,
            token: token ? 'present' : 'missing',
            seriesId,
            targetUrl: seriesId ? `${CREATE_SERIES}/${seriesId}` : HOME
        });

        if (token) {
            localStorage.setItem('authToken', token);
            console.log('URL Debug:', {
                currentUrl: location.pathname + location.search,
                token: token ? 'present' : 'missing',
                seriesId,
                targetUrl: seriesId ? `${CREATE_SERIES}/${seriesId}` : HOME
            });
            if (seriesId) {
                const targetUrl = `${CREATE_SERIES}/${seriesId}`;
                console.log('About to navigate to:', targetUrl);
                // Try with replace: true to avoid history issues
                navigate(targetUrl, { replace: true });
            } else {
                navigate(HOME);
            }
        } else {
            console.error('No token received');
            navigate('/login');
        }
    }, [location, navigate]);

    return <div>Authenticating...</div>;
};
export default AuthCallbackHandler
